import { Button, Stack } from "@mui/material";
import { type NavigateFunction } from "react-router-dom";

interface IProps<T extends { id: number }> {
  row: T;
  navigate: NavigateFunction;
  onClickAcquireCommercialBook: (row: T) => void;
}

/**
 * モニタリング結果・詳細画面のDataGridで共通利用するAction列のセル
 */
export const CommercialMonitoringActionCell = <T extends { id: number }>(
  props: IProps<T>
): JSX.Element => {
  const { row, navigate, onClickAcquireCommercialBook } = props;

  return (
    <Stack direction="row" spacing={1}>
      <Button
        onClick={() => {
          navigate(`/commercial-monitoring/detail/${row.id}`);
        }}
        sx={{
          bgcolor: "#F4A150",
          "&:hover": {
            backgroundColor: "#DF9B4A",
          },
        }}
        variant="contained"
      >
        モニタリング結果
      </Button>
      <Button
        onClick={() => {
          onClickAcquireCommercialBook(row);
        }}
        variant="outlined"
      >
        商業登記取得
      </Button>
    </Stack>
  );
};
